import { CartPolicy } from './types';
import {
  findExistingCartLine,
  getAttr,
  mergeDedupAttributes,
  parseLineMaxQuantity,
  pass,
} from './cartLineHelpers';

export const duplicateLinePolicy: CartPolicy = (input, cart, meta) => {
  const lines = input.lineItemsToAdd;
  if (!lines?.length || !cart) return pass(input);

  const reasons: string[] = [];
  const next = lines.map((line) => {
    if (getAttr(line.attributes, 'sibling_id')) return line;

    const existing = findExistingCartLine(line, cart, meta.store);
    if (!existing) return line;

    const effectiveMax =
      parseLineMaxQuantity(line.attributes) ??
      parseLineMaxQuantity(existing.attributes);
    reasons.push(`merge into existing line ${existing.id}`);
    return {
      merchandiseId: existing.merchandise.id,
      quantity: 1,
      attributes: mergeDedupAttributes(
        existing.attributes,
        line.attributes,
        effectiveMax,
      ),
    };
  });

  return { input: { ...input, lineItemsToAdd: next }, reasons };
};
